var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30568",
    "data-name": "Path 30568",
    d: "M7.786,1.907a.194.194,0,0,0-.106.009l-.025.009A8.525,8.525,0,1,0,18.492,12.76l.014-.037a.194.194,0,0,0-.237-.241,8.478,8.478,0,0,1-5.086.089A7.774,7.774,0,0,1,7.845,7.234a8.466,8.466,0,0,1,.09-5.086.194.194,0,0,0-.149-.241Zm12.3,11.44,0-.008a1.89,1.89,0,0,0-2.324-2.475l-.02.006a6.783,6.783,0,0,1-4.083.074l-.008,0A6.077,6.077,0,0,1,9.475,6.764l0-.008a6.77,6.77,0,0,1,.075-4.081l.007-.02A1.89,1.89,0,0,0,7.091.325,10.221,10.221,0,1,0,20.083,13.347Z",
    transform: "translate(-0.209 -0.207)",
    fill: "#474a4e",
    fillRule: "evenodd",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/moonIcon.693401b3e7b25f54df4895e2133acbaf.svg";
export { ForwardRef as ReactComponent };